module.exports = __webpack_public_path__ + "static/chain-013199ef37fd006e549716ced4e15bbb.png";